var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeater = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.51 23.99h-.3a5.21 5.21 0 0 1-3.62-1.74 5.256 5.256 0 0 1 .16-7.166V3.758A3.75 3.75 0 0 1 10.5.01a3.75 3.75 0 0 1 3.75 3.748v11.326l.16.18a5.17 5.17 0 0 1 1.33 3.788 5.227 5.227 0 0 1-5.23 4.998zm0-22.49a2.25 2.25 0 0 0-2.26 2.258v11.656a.73.73 0 0 1-.25.58 3.758 3.758 0 0 0 .874 6.169c.443.213.925.334 1.416.358a3.78 3.78 0 0 0 2.71-.97 3.74 3.74 0 0 0 1.24-2.559 3.67 3.67 0 0 0-1-2.699 3 3 0 0 0-.24-.3.77.77 0 0 1-.25-.56V3.759A2.25 2.25 0 0 0 10.5 1.51z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 20.991a2.25 2.25 0 0 1-2.207-2.688 2.249 2.249 0 0 1 4.078-.81A2.249 2.249 0 0 1 10.5 20.99zm0-2.998a.751.751 0 0 0-.14 1.486.75.75 0 1 0 .14-1.486"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 17.992a.76.76 0 0 1-.75-.75V3.759a.75.75 0 0 1 1.5 0v13.485a.75.75 0 0 1-.75.75zM18 4.509h-1.5a.75.75 0 1 1 0-1.5H18a.75.75 0 1 1 0 1.5m0 4.488h-1.5a.75.75 0 1 1 0-1.5H18a.75.75 0 1 1 0 1.5m0 4.498h-1.5a.75.75 0 1 1 0-1.5H18a.75.75 0 1 1 0 1.5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgHeater;